import moment from "moment";
import { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { RenderHtml3 } from "../components/renderhtml";
import { BottomIfor } from "./bottom/bottominfo";
import { ButtonforPh } from "./bottom/buttomforph";
import { GetSingleNew } from "./ajax";
import { Floatingpc } from "../components/floatingpc";
import { Floatingph } from "../components/floatingph";
export function ActivityDetail(props) {
  const [data, setData] = useState({
    createTime: 0,
    title: "",
    newsType: 0,
    content: "",
  });
  const [shows, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  useEffect(() => {
    document.addEventListener("touchstart", hideFloating);
  }, []);
  const loadnew = async (id) => {
    let res = await GetSingleNew(id);
    if (res.code !== 0) {
      return;
    } else {
      setData(res.data);
    }
  };

  useEffect(() => {
    loadnew(props.match.params.id * 1);
  }, [props.match.params.id]);
  const arr = [
    "",
    "KK幼儿园",
    "KK魔法杯",
    "三宝活动室",
    "KK头条站",
    "KK绘画社",
    "KK训练营",
    "KK图书馆",
  ];
  const newsColorType = [
    "",
    "typegreen",
    "typepurple",
    "typeyellow",
    "typegray",
    "typepink",
    "typegreenblack",
    "typegreenblue",
  ];
  const newColorPh = [
    "",
    "typegreenph",
    "typepurpleph",
    "typeyellowph",
    "typegrayph",
    "typepinkph",
    "typegreenblackph",
    "typeblueph",
  ];
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <Floatingpc
          show={shows}
          showWindow={showWindow}
          text={text}
          setText={setText}
        />
        <div className="activitydetailbox">
          <div className="magic-girl"></div>
          <div className="activitydate">
            {moment(data.createTime * 1000).format("YYYY .MM .DD")}
          </div>
          <div className="activitytitle">{data.title}</div>
          <div className="activitytype">
            <div className={`${newsColorType[data.newsType]}`}>
              {arr[data.newsType]}
            </div>
            <div className="activityentext">NEWS & EVENTS</div>
          </div>
          {/* <div className="newscover">
            <img src={data.newsImage} alt="" width="100%" height="100%" style={{ objectFit: "cover" }} />
          </div> */}
          <div className="newsdetailcontent">
            <div style={{ marginTop: 10 }}>
              <RenderHtml3 flow={1000} state={{ content: data.content }} />
            </div>
            <div>
              <span
                onClick={() => {
                  props.history.push(`/notes`);
                }}
              >
                返回活动列表{" "}
              </span>
              <span>》》</span>
            </div>
          </div>
        </div>
        <BottomIfor />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <Floatingph
          showmp={showmp}
          showFloating={showFloating}
          text={text}
          setText={setText}
        />
        <div className="activitydetailboxph">
          <div className="magic-girlph"></div>
          <div className="activitydateph">
            {moment(data.createTime * 1000).format("YYYY .MM .DD")}
          </div>
          <div className="activitytitleph">{data.title}</div>
          <div className="activitytypeph">
            <div className={`${newColorPh[data.newsType]}`}>{arr[data.newsType]}</div>
            <div className="activityentextph">NEWS & EVENTS</div>
          </div>
          {/* <div className="newscoverph">
            <img src={data.newsImage} alt="" width="100%" height="100%" style={{ objectFit: "cover" }} />
          </div> */}
          <div className="newsdetailcontentph">
            <div>
              <RenderHtml3
                flow={"100%"}
                state={{ content: parseStr(data.content) }}
              />
            </div>
            <div>
              <span
                onClick={() => {
                  props.history.push(`/notes`);
                }}
              >
                返回活动列表{" "}
              </span>
              <span>》》</span>
            </div>
          </div>
        </div>
        <ButtonforPh />
      </Col>
    </Row>
  );
}
function parseStr(str = "") {
  return str.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, "")) / 1.7);
    return `font-size:${newValue}`;
  });
}
